export default __webpack_public_path__ + "static/media/sanjay.18ee41ca.jpeg";